import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { ExpenseModel } from './model/expense.model';
import { ExpenseService } from './expense.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { EmployeeCategoryModel } from '../../employees/employee-category/employee-category/model/employee-category.model';
import { forkJoin } from 'rxjs';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.scss'],
  standalone: false
})
export class ExpenseComponent {

  expenseList: ExpenseModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [];
  displayedColumns = ['code', 'name', 'description', 'expense_type_name', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: ExpenseModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<ExpenseModel>(true, []);
  dataSource = new MatTableDataSource(this.expenseList);
  IsDownloading: boolean = false;
  expenseType: any = [];
  isFilterReady = false;
  permission: any;

  constructor(private breakpointObserver: BreakpointObserver,
    private expenseService: ExpenseService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    private router: Router, private stateManagerService: StateManagerService,) {

    this.expenseList = [];
    this.getExpenseType();
    this.permission = permissionService.getPagePermission("expense");
    console.log(this.permission);

  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    // this.loadData();

  }

  getExpenseType() {
    let requestData = {
      "search": {
        "filters": {
          "simpleSearch": [],
          "advSearch": [],
          "scope": {
            "limit": 10,
            "offset": 0
          }
        },
        "sort": [
          {
            "column": "name",
            "order": "asc"
          }
        ]
      }
    }
    this.expenseService.getExpenseType(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.expenseType = response.data.expenses_type;
          this.generateFilterList();
          this.isFilterReady = true;
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get expense type from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  generateFilterList() {
    this.filter = [
      {
        title: "Code",
        column: "e.code",
      },
      {
        title: "Name",
        column: "e.name",
      },
      {
        title: "Description",
        column: "e.description",
      },
      {
        title: "Expense Type",
        column: "e.expense_type",
        type: "boolean",
        values: this.expenseType.map((et: any) => ({
          title: et.name,
          value: String(et.id) // Make sure value is a string
        }))
      },
    ];
  }

  /** 
  * Set the datasource
  */
  setDataSource(expenseList: ExpenseModel[]) {
    this.dataSource = new MatTableDataSource(expenseList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('e.name', 'asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.expenseList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.expenseList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
   * Check and apply default filter for is_system = 0.
   **/
  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "e.is_system")
    ) {
      defFilter.push({
        column: "e.is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(expenseInfo: ExpenseModel): void {
    const expenseId = expenseInfo.id;
    const message = `Are you sure, you want to delete ` + (expenseInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.expenseService.delete(expenseInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + expenseInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.expenseService.getExpenseList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.expenseList = response.data.expenses;
        //  console.log(this.expenseList)
        this.setDataSource(this.expenseList);
        this.pagingData.length = response.data.total_count;

        if (this.pagingData.length === 0) {
          const snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          };
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.stateManagerService.setState(this.constructor.name, requestData);
          // this.onRowSelected(this.expenseList[0]);
        }

      } else {
        const snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }

      this.isLoading = false;
    });
  }

  /**
  * On expenseInfo selected
  * @param expenseInfo 
  */
  onRowSelected(expenseInfo: ExpenseModel): void {
    this.selectedItem = expenseInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {

    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(expenseInfo: ExpenseModel): void {

    this.router.navigate(['system/expense-edit', expenseInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new expense
   */
  addClicked(): void {

    this.router.navigate(['system/expense-edit', 0]);

  }
  expenseTypeClick(): void {

    this.router.navigate(['system/expense/expense-type']);

  }


  // exportClicked() {
  //   this.isLoading = true;
  //   let requestData = this.buildRequestData();
  //   this.IsDownloading = true;
  //   this.expenseService['downloadExcel'](requestData)
  //     .subscribe({
  //       next: (blob: Blob | MediaSource) => {
  //         // Download logic
  //         this.IsDownloading = false;
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.download = 'expense_list.csv'; // Adjust filename if needed
  //         link.click();
  //         window.URL.revokeObjectURL(url);
  //         this.isLoading = false;


  //       },
  //       error: (_error: any) => {
  //         // Handle errors
  //         this.IsDownloading = false;
  //         let snackBarData: SnackBarData = {
  //           message: 'Failed to update. Connection to the server failed',
  //           title: 'Failed!!!',
  //           type: 'error'
  //         }
  //         this.snackBarService.openSnackBar(snackBarData);
  //         this.isLoading = false;
  //         // Display user-friendly error message to the user
  //       }
  //     }
  //     );
  // }


}
